import React, { Component, PropTypes } from 'react';
import { Row } from 'react-bootstrap';
import Col from 'components/core/Col';
import ComponentTitle from './ComponentTitle';
import Image from 'components/Image';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';

/**
 * Class representing the clickable images(Toolbox) which can be integrated to any pages defined in the config.
 */
class Toolbox extends Component {

  static propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    textColor: PropTypes.string,
    showImageTitle: PropTypes.bool,
    imageTitleAlignment: PropTypes.string,
    backgroundColor: PropTypes.string,
    titleBackgroundColor: PropTypes.string,
    padding: PropTypes.number,
    spans: PropTypes.object,
    images: PropTypes.array.isRequired,
    titleType: PropTypes.string
  }

  static defaultProps = {
    title: 'Toolbox',
    padding: 16,
    spans: {
      'xs': 6
    },
    titleType: TITLE_TYPE.MODULE_TITLE
  }

  render() {
    const {
      title,
      titleColor,
      textColor,
      showImageTitle,
      imageTitleAlignment,
      backgroundColor,
      titleBackgroundColor,
      padding,
      spans,
      images = [],
      titleType
    } = this.props;

    if (!images.length) {
      return null;
    }

    const inlineDisplay = imageTitleAlignment === 'left' || imageTitleAlignment === 'right';
    const titleFirst = imageTitleAlignment === 'left' || imageTitleAlignment === 'top';

    return (
      <div className='Toolbox' style={{backgroundColor}} >
        <div className='Toolbox-header' style={{backgroundColor: titleBackgroundColor}}>
          {title ? <ComponentTitle titleType={titleType} color={titleColor} title={title} /> : null}
        </div>
        <Row className='Toolbox-row' style={{padding: padding + 'px'}}>
          {images.map((image, i) => <ClickableImage
            key={i}
            image={image}
            imageTitleAlignment={imageTitleAlignment}
            textColor={textColor}
            spans={spans}
            showImageTitle={showImageTitle}
            inlineDisplay={inlineDisplay}
            titleFirst={titleFirst}
          />)}
        </Row>
      </div>
    );
  }
}

class ClickableImage extends Component {
  static propTypes = {
    image: PropTypes.object.isRequired,
    textColor: PropTypes.string,
    spans: PropTypes.object,
    inlineDisplay: PropTypes.bool,
    titleFirst: PropTypes.bool,
    showImageTitle: PropTypes.bool,
    imageTitleAlignment: PropTypes.string
  };

  static defaultProps = {
    inlineDisplay: false,
    titleFirst: true,
    showImageTitle: true
  }

  render() {
    const {
      image: {
        title,
        staticUri,
        destinationUri,
        altText = title,
        linkTarget = '_top'
      } = {},
      imageTitleAlignment,
      textColor,
      spans = {},
      inlineDisplay,
      showImageTitle,
      titleFirst
    } = this.props;

    const content = [];

    if (showImageTitle) {
      const textStyle = {
        color: textColor
      };

      content.push(
        <h3 key={content.length} className='Toolbox-ClickableImage-Thumbnail-imageTitle' style={textStyle}>
          {destinationUri ? <a style={textStyle} title={title} href={destinationUri} target={linkTarget}>{title}</a> : title}
       </h3>
     );
    }

    let imageWidth;
    if (imageTitleAlignment === 'top' || imageTitleAlignment === 'bottom') {
      imageWidth = '140';
    } else {
      imageWidth = '100';
    }

    const imageThumbnail = (
      <div key={content.length} className='Toolbox-ClickableImage-Thumbnail'>
          <Image width={imageWidth} src={staticUri} alt={altText} imageClassNames={"Toolbox-ClickableImage-Thumbnail-image"} />
          {destinationUri ? <a className='Toolbox-ClickableImage-Thumbnail-imageLink' href={destinationUri} target={linkTarget}/> : null}
      </div>
    );

    if (titleFirst) {
      content.push(imageThumbnail);
    } else {
      content.unshift(imageThumbnail);
    }

    return (
      <Col spans={spans}>
        <div className='Toolbox-clickableImageWrapper'>
          <div className={inlineDisplay ? 'Toolbox-clickableImageContent Toolbox-clickableImageContent--inlineContent' : 'Toolbox-clickableImageContent'}>
            {content}
          </div>
        </div>
      </Col>
    );
  }
}

export default Toolbox;



// WEBPACK FOOTER //
// ./app/components/shared/Toolbox.js